import { Directive } from '../../../types';

import {
  IngressClass,
  KubernetesSetupFormData,
  KubernetesSetupPolicyPayload,
  StorageClass,
} from './types';

/**
 * Builds the API payload from form data
 * Wraps values in Directive structure as expected by backend
 */
export function buildKubernetesSetupPayload(
  formData: KubernetesSetupFormData
): KubernetesSetupPolicyPayload {
  // Handle ingressControllers - can be array of objects or undefined
  // Map to Array<Directive<IngressClass>> objects
  const ingressControllers: Array<Directive<IngressClass>> = Array.isArray(
    formData.ingressControllers
  )
    ? formData.ingressControllers
        .filter((ic) => ic.name && ic.name.trim())
        .map((ic) => ({
          value: {
            name: ic.name,
            type: 'custom',
            globallyBlocked: false,
            blockedNamespaces: [],
          },
          enforce: false,
        }))
    : [];

  // Handle storageClasses - can be array of objects or undefined
  // Backend expects an array of Directives, each wrapping a StorageClass object
  const storageClasses: Array<Directive<StorageClass>> = Array.isArray(
    formData.storageClasses
  )
    ? formData.storageClasses
        .filter((sc) => sc.name && sc.name.trim())
        .map((sc) => ({
          value: {
            name: sc.name,
            allowVolumeExpansion: sc.allowVolumeExpansion,
          },
          enforce: false,
        }))
    : [];

  return {
    UseLoadBalancer: {
      value: formData.useLoadBalancer,
      enforce: false,
    },
    UseServerMetrics: {
      value: formData.useServerMetrics,
      enforce: false,
    },
    EnableResourceOverCommit: {
      value: formData.enableResourceOverCommit,
      enforce: false,
    },
    ResourceOverCommitPercentage: {
      value: formData.resourceOverCommitPercentage,
      enforce: false,
    },
    IngressAvailabilityPerNamespace: {
      value: formData.ingressAvailabilityPerNamespace,
      enforce: false,
    },
    AllowNoneIngressClass: {
      value: formData.allowNoneIngressClass,
      enforce: false,
    },
    StorageClasses: storageClasses,
    IngressClasses: ingressControllers,
    RestrictStandardUserIngressW: {
      value: formData.restrictStandardUserIngressW,
      enforce: false,
    },
    // TODO: not setup yet
    DeploymentOptions: {
      value: {},
      enforce: false,
    },
    EndpointChangeWindow: {
      value: formData.changeWindow,
      enforce: false,
    },
  };
}
